<template>
  <main>
    <div class="tab-header">
      <div class="container-fluid">
        <div class="row mb-20">
          <div class="col-2">
            <h4>公式維護</h4>
          </div>
          <div class="col-10 text-right">
            <a
              class="btn btn-default top-button"
              @click="formulaEstimate()"
              >公式試算
            </a>
            <a
              class="btn btn-default top-button"
              @click="$router.push({ name: 'ProductMenuPage' })"
              >回商品維護
            </a>
          </div>
        </div>
        <div class="text-right">
          <span>
            公  司: 
            <span class="font-weight-bold">{{productData.company.COMPSNM}}</span>  
            <span class="font-weight-bold">{{" " + getProductTypeName(productData.productType)}}</span>
            險種種類:
            <span class="font-weight-bold">{{getContractTypeName(productData.contractType)}}</span>
            商品名稱:
            <span class="font-weight-bold">
              {{productData.insuranceName + (productData.insuranceCode? " (" + productData.insuranceCode + ")" : "")}}
            </span>
          </span>
        </div>
        <ul class="nav nav-pills" role="tablist">
          <li class="nav-item" @click="$router.push({ name: 'InvestFormulaSummary' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="investFormulaNavLink"
              :class="{ active: $route.name === 'InvestFormulaSummary' }"
              >保障摘要</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'InvestPolicyValue' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="investFormulaNavLink"
              :class="{ active: $route.name === 'InvestPolicyValue' }"
              >保單價值</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'InvestDeathAndDisabilityBenefit' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="investFormulaNavLink"
              :class="{ active: $route.name === 'InvestDeathAndDisabilityBenefit' }"
              >身故及完全失能保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'InvestLivingBenefit' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="investFormulaNavLink"
              :class="{ active: $route.name === 'InvestLivingBenefit' }"
              >生存保險金</a
            >
          </li>
          <li class="nav-item" @click="$router.push({ name: 'InvestMaturityBenefit' })">
            <a
              class="nav-link show"
              role="tab"
              data-toggle="tab"
              id="investFormulaNavLink"
              :class="{ active: $route.name === 'InvestMaturityBenefit' }"
              >滿期保險金</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>

  </main>
</template>

<script>
import ThisMixin from "./InsuranceProduct";

export default {
  name: "InvestFormula",
  mixins: [ThisMixin],
  data() {
    return {
      productData: null,
    };
  },
  methods: {
    getProductTypeName(productType) {
      return this.options.productType.filter((x) => x.value == productType)[0]
        .name;
    },
    getContractTypeName(contractType) {
      return this.options.contractType.filter((x) => x.value == contractType)[0]
        .name;
    },
    formulaEstimate() {
      if (
        this.productData.productType == "1" ||
        this.productData.productType == "4"
      ) {
        this.$router.push({ name: "CoverageFormulaValidation" }); //試算公式(傳統型、傳統型取大)
      } else if (
        this.productData.productType == "2" ||
        this.productData.productType == "3"
      ) {
        this.$router.push({ name: "InvestCoverageFormulaValidation" }); //試算公式(投資型、利率變動型)
      }
    },
  },
  beforeMount() {
    this.productData = JSON.parse(localStorage.productData);
  },
  mounted() {
    this.$router.push({ name: "InvestFormulaSummary" });
  },
};
</script>
<style scoped>
.mb-20 {
  margin-bottom: 20px;
}
.container-fluid {
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
}
.nav-pills .nav-link {
  background: #f5f5f5;
  border: 1px solid #c2c4c7;
  margin: 2px 2px;
  border-radius: 8px 8px;
}
.nav-pills .nav-link:hover {
  background: #fff;
}
.nav-pills .active {
  color: #00aa42;
  font-weight: 800;
  border: 2px solid #00aa42;
  background: #fff;
}
.top-button {
  height: 30px;
  padding-top: 0px;
  line-height: 28px;
}
.tab-content {
  padding-bottom: 100px;
}
.nav-item {
  cursor: pointer;
}
</style>
